<!--
 * @Author: 杜娇艳 12104317+du-jiaoyan@user.noreply.gitee.com
 * @Date: 2025-06-15 14:24:00
 * @LastEditors: 杜娇艳 12104317+du-jiaoyan@user.noreply.gitee.com
 * @LastEditTime: 2025-06-15 16:59:31
 * @FilePath: /game-console/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* 全局样式重置 */
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  height: 100%;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/* 全局表格样式 */
.el-table th {
  text-align: center !important;
}

.el-table td {
  text-align: center !important;
}

.el-table .cell {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-main {
  padding: 10px !important;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  background: #fff;
  padding: 10px;
  border-radius: 4px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .pagination-container {
    justify-content: center;
  }

  .el-pagination {
    flex-wrap: wrap;
  }
}
</style>
